import { render, staticRenderFns } from "./ChildScheduleEditor.vue?vue&type=template&id=1ed426c9&scoped=true&"
import script from "./ChildScheduleEditor.vue?vue&type=script&lang=ts&"
export * from "./ChildScheduleEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ChildScheduleEditor.vue?vue&type=style&index=0&id=1ed426c9&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed426c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
